import React, { Component} from "react";
import {


  Link
} from "react-router-dom";
import axiosInstance from "../../axios-project";
import AdminTable from "../../components/AdminTable/AdminTable";
import "bootstrap/dist/css/bootstrap.min.css";
import SignupModal from "../../components/AdminModal/SignupModal";
import RoleModal from "../../components/AdminModal/RoleModal";
import PasswordModal from "../../components/AdminModal/PasswordModal";
import StakeholderRoleModal from "../../components/AdminModal/StakeholderRoleModal";
import StateModal from "../../components/AdminModal/StateModal";

class AdminOverview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      users: [],
      currentUserID: null,
      passwordModal: false,
      signupModal: false,
      roleModal: false,
      stakeholderModal: false,
      stateModal: false,
    };
  }

  togglePasswordModal = () => {
    this.setState(prevState => ({
      passwordModal: !prevState.passwordModal
    }));
  };
  toggleSignupModal = () => {
    this.setState(prevState => ({
      signupModal: !prevState.signupModal
    }));
  };
  toggleRoleModal = () => {
    this.setState(prevState => ({
      roleModal: !prevState.roleModal
    }));
  };
  toggleStakeholderModal = () => {
    this.setState(prevState => ({
      stakeholderModal: !prevState.stakeholderModal
    }));
    if (this.state.stakeholderModal) {
      this.fetchStakeholderRoles();
    }
  };
  toggleStateModal = () => {
      this.setState(prevState => ({
          stateModal: !prevState.stateModal
      }));
  }

  fetchAdminDetails = () => {
    axiosInstance
      .get("/users")
      .then(response => {
        this.setState(prevState => {
          return {
            users: response.data
          };
        });
      })
      .catch(error => {
        console.log(error);
      });
  };

  fetchStakeholderRoles = () => {
    axiosInstance
        .get("/stakeholder_role_lkp")
        .then(response => {
            response.data.sort((a, b) => (a.display_order < b.display_order) ? -1 :
                (a.display_order > b.display_order ? 1 : 0));
          this.setState(prevState => {
            return {
              stakeholder_roles: response.data
            };
          });
        })
        .catch(error => {
          console.log(error);
        });
  };

  addStakeholderRole = values => {
    axiosInstance
        .post("/stakeholder_role_lkp", values)
        .then(response => {
          this.fetchStakeholderRoles();
        })
        .catch(error => {
          console.log(error);
        });
  };

  updateStakeholderRoles = valueList => {
    var requests = [];
    for (var i = 0; i < valueList.length; i++) {
      if (valueList[i]["stakeholder_role_id"]) {
        requests.push(
            axiosInstance.put("/stakeholder_role_lkp/" + valueList[i]["stakeholder_role_id"], valueList[i]));
      }
    }
    Promise.all(requests)
        .then(response => {
          this.fetchStakeholderRoles();
        })
        .catch(error => {
          console.log(error);
        });
  }

  componentDidMount() {
    this.fetchAdminDetails();
    this.fetchStakeholderRoles();
  }

  toggleModalHandler = id => {
    this.setState(prevState => {
      return {
        currentUserID: id
      };
    });
  };

  render() {
    const isAdmin = JSON.parse(localStorage.getItem("role")).some(
      r => r.name === "ROLE_ADMIN"
    );
    const curr_user = this.state.users.find(
        a => a.id === this.state.currentUserID
    );
    return (
      <div>
        {isAdmin ? (
          <div className="text-right">
            <Link to="/logging">
            <button
                className={"btn btn-outline-primary btn-sm my-2"}
                type="button"
               
            >
              Data Change Logs
            </button>
            </Link>
            {"   "}
            <button
                className={"btn btn-outline-primary btn-sm my-2"}
                type="button"
                onClick={() => {
                  this.toggleStakeholderModal();
                }}
            >
              Stakeholder Roles
            </button>
            {"   "}
            <button
              className={"btn btn-outline-primary btn-sm my-2"}
              type="button"
              onClick={() => {
                this.setState({ currentUserID: null });
                this.toggleSignupModal();
              }}
            >
              Create New User
            </button>
          </div>
        ) : (
          ""
        )}
        <AdminTable
          clicked={this.toggleModalHandler}
          users={isAdmin ? this.state.users : []}
          toggleRoleModal={this.toggleRoleModal}
          togglePasswordModal={this.toggleSignupModal}
          toggleStateModal={this.toggleStateModal}
        />
        <RoleModal
          toggle={this.toggleRoleModal}
          modal={this.state.roleModal}
          currentUserID={this.state.currentUserID}
          curr_user={curr_user}
          fetchAdminDetails={this.fetchAdminDetails}
        />
        <SignupModal
          toggle={this.toggleSignupModal}
          modal={this.state.signupModal}
          curr_user={curr_user}
          currentUserID={this.state.currentUserID}
          fetchAdminDetails={this.fetchAdminDetails}
        />
        <PasswordModal
          toggle={this.togglePasswordModal}
          modal={this.state.passwordModal}
          currentUserID={this.state.currentUserID}
          fetchAdminDetails={this.fetchAdminDetails}
        />
        <StakeholderRoleModal
          toggle={this.toggleStakeholderModal}
          modal={this.state.stakeholderModal}
          fetch={this.fetchStakeholderRoles}
          add={this.addStakeholderRole}
          update={this.updateStakeholderRoles}
          roles={this.state.stakeholder_roles}
        />
        <StateModal
            toggle={this.toggleStateModal}
            modal={this.state.stateModal}
            fetchAdminDetails={this.fetchAdminDetails}
            currentUserID={this.state.currentUserID}
            curr_user={curr_user}
        />
      </div>
    );
  }
}
export default AdminOverview;
